<template>

        <v-select
                prepend-icon="view_stream"
                :items="items"
                v-model="item"
                :label="$t('afip.factura.labels.CondicionVenta')"
                :loading="loading"
                :error="hasInputErrors('CondicionVenta')"
                :error-messages="getInputErrors('CondicionVenta')"
                color="secondary"
                item-color="secondary"
                :clearable="clearable"
                :multiple="multiple"
                :chips="chips"
                :solo="solo"
        ></v-select>

</template>

<script>

    import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'


    export default {
        name: "CondicionVentaCombobox",
        mixins: [InputErrorsByProps, RequiredRule],
        props:{
            value: {type: [String, Array]},
            clearable: {type:Boolean, default: false},
            multiple: {type:Boolean, default: false},
            solo: {type:Boolean, default: false},
            chips: {type:Boolean, default: false}
        },
        data() {
            return {
                items: ['Contado', 'Tarjeta de Débito', 'Tarjeta de Crédito', 'Cuenta Corriente', 'Ticket', 'Otra'],
                loading: false
            }
        },
        computed: {
           item: {
                get() { return this.value },
                set(val) {this.$emit('input', val)}
            }
        },
        methods: {
            validate(){
              return this.$refs.form.validate()
            }
        }
    }
</script>

<style scoped>

</style>

